import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit {
  // options
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  showYAxisLabel = true;
  colorScheme = {
    domain: ['#A10A28', '#C7B42C', '#1338BE']
  };

  // line, area
  autoScale = true;

  @Input() view: any[];
  @Input() chartData: any[];
  @Input() legendPosition: any;
  @Input() showXAxis: boolean;
  @Input() xAxisTickFormatting: (arg: any) => void;

  constructor() { }

  ngOnInit(): void {
  }

  // xAxisTickFormatting = val => this.chartData[0].series[val].value;
}
